if (
  !customElements.get('quick-add-modal') &&
  typeof ModalDialog !== 'undefined'
) {
  class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

      this.addEventListener('product-info:loaded', ({ target }) => {
        target.addPreProcessCallback((html) => this.preprocessHTML(html));
      });
    }

    hide(preventFocus = false) {
      const cartNotification =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      if (cartNotification) {
        cartNotification.setActiveElement(this.openedBy);
      }

      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;

      super.hide();
    }

    show(opener) {
      const spinner = opener.querySelector('.loading__spinner');

      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const productElement = doc.querySelector('product-info');

          this.preprocessHTML(productElement);

          if (window.HTMLUpdateUtility) {
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );
          } else {
            this.modalContent.innerHTML = productElement.outerHTML;
          }

          if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    preprocessHTML(productElement) {
      productElement?.classList.forEach((c) => {
        if (c.startsWith('color-') || c === 'gradient') {
          this.modalContent.classList.add(c);
        }
      });

      this.preventDuplicatedIDs(productElement);
      this.removeDOMElements(productElement);
      this.removeGalleryListSemantic(productElement);
      this.updateImageSizes(productElement);
      this.preventVariantURLSwitching(productElement);
    }

    preventVariantURLSwitching(productElement) {
      productElement?.setAttribute('data-update-url', 'false');
    }

    removeDOMElements(productElement) {
      if (!productElement) return;

      productElement.querySelector('pickup-availability')?.remove();
      productElement.querySelector('product-modal')?.remove();
      productElement.querySelectorAll('modal-dialog')?.forEach((m) => m.remove());
    }

    preventDuplicatedIDs(productElement) {
      if (!productElement) return;

      const oldId = productElement.dataset.section;
      const newId = `quickadd-${oldId}`;

      productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

      for (const a of productElement.attributes) {
        if (a.value.includes(oldId)) {
          productElement.setAttribute(a.name, a.value.replace(oldId, newId));
        }
      }

      productElement.dataset.originalSection = oldId;
    }

    removeGalleryListSemantic(productElement) {
      const gallery = productElement?.querySelector('[id^="Slider-Gallery"]');
      if (!gallery) return;

      gallery.setAttribute('role', 'presentation');
      gallery
        .querySelectorAll('[id^="Slide-"]')
        .forEach((el) => el.setAttribute('role', 'presentation'));
    }

    updateImageSizes(productElement) {
      const container = productElement?.querySelector('.product');
      if (!container?.classList.contains('product--columns')) return;

      const imgs = container.querySelectorAll('.product__media img');
      if (!imgs.length) return;

      let sizeStr =
        '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

      if (container.classList.contains('product--medium')) {
        sizeStr = sizeStr.replace('715px', '605px');
      } else if (container.classList.contains('product--small')) {
        sizeStr = sizeStr.replace('715px', '495px');
      }

      imgs.forEach((img) => img.setAttribute('sizes', sizeStr));
    }
  }

  customElements.define('quick-add-modal', QuickAddModal);
}